var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#EFEFEF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m723-192-51-51 56-57H576v-72h152l-56-57 51-51 141 144-141 144Zm-555-96q-29.7 0-50.85-21.15Q96-330.3 96-360v-384q0-29.7 21.15-50.85Q138.3-816 168-816h479.57Q678-816 699-794.85T720-744l1 168q-19 1-37.5 3.5T648-565v-129L408-528 168-694v334h313q-1 4-1 10v14q0 10 2 24t4 24H168Zm55-456 185 129 185-129H223Zm-55 384v-384 384Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/sendEmail.6e54765ecc712ccdf4734e5ad0637684.svg";
export { ForwardRef as ReactComponent };